import React from 'react';
import { Video, Render } from '../platformui/';
export default (props) => (
    <Video
      {...props}
      VideoText={Render.Property(props.VideoText, 'VideoText')}
      hideCaption={props.CurrentPageProps.DisableVideoBlockText}
      hideTitle={props.CurrentPageProps.DisableVideoBlockText} />
);
